import React from 'react';

function Heart(props: object) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0006 21L20.3781 12.5025C21.2573 11.6233 21.7512 10.4309 21.7512 9.18751C21.7512 7.94414 21.2573 6.7517 20.3781 5.87251C19.4989 4.99331 18.3065 4.49939 17.0631 4.49939C15.8198 4.49939 14.6273 4.99331 13.7481 5.87251L12.0006 7.50001L10.2531 5.87251C9.37393 4.99331 8.18148 4.49939 6.93812 4.49939C5.69475 4.49939 4.50231 4.99331 3.62312 5.87251C2.74393 6.7517 2.25 7.94414 2.25 9.18751C2.25 10.4309 2.74393 11.6233 3.62312 12.5025L12.0006 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Heart;
